const acceptableFileExtensions = [
  {
    ext: 'pdf',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  {
    ext: 'docx',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'doc',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'jpg',
    previewLogo: true,
    previewImage: true,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  {
    ext: 'xlsx',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'msg',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'pptx',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'tif',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  // {
  //   ext: 'wmv',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'xls',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'png',
    previewLogo: true,
    previewImage: true,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  {
    ext: 'txt',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'ppt',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'mp4',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'csv',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'mp3',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'mov',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'eps',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ai',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'psd',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'rtf',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'tiff',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  {
    ext: 'gif',
    previewLogo: true,
    previewImage: true,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  // {
  //   ext: 'swf',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'xlsm',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'indd',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'oft',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'docm',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'jpeg',
    previewLogo: true,
    previewImage: true,
    previewPackage: false,
    uploadLogo: true,
    uploadImage: true,
    uploadPackage: true
  },
  // {
  //   ext: 'mpeg',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'bmp',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'pub',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'pptm',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'wav',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'mpg',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'mpp',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'dot',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'xps',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'avi',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'fla',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ppsx',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ps',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'm4v',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'sea',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'idml',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'page',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'eml',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'aif',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'potx',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'vsd',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'indt',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'snag',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ics',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'log',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'wma',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'dotx',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'inx',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'xlsb',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'mdi',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'pps',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'aiff',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'otf',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'asf',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  {
    ext: 'xlt',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: '3gp',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  {
    ext: 'dotm',
    previewLogo: false,
    previewImage: false,
    previewPackage: false,
    uploadLogo: false,
    uploadImage: false,
    uploadPackage: true
  },
  // {
  //   ext: 'dpp',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ico',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'pfb',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'pfm',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'ttf',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'vsdx',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'm4a',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // },
  // {
  //   ext: 'wpp',
  //   previewLogo: false,
  //   previewImage: false,
  //   previewPackage: false,
  //   uploadLogo: false,
  //   uploadImage: false,
  //   uploadPackage: true
  // }
];

export default acceptableFileExtensions;
